(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('change', function(event) {
    if (!event.target.matches('.product-form select[name="id"]')) return;
    var section = event.target.closest('.product-info');
    if (!section) return;
    var option = event.target.options[event.target.selectedIndex];
    var price = section.querySelector('[id^="ProductPrice-"]');
    var button = section.querySelector('.product-submit');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (button) {
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? button.dataset.soldOut : button.dataset.addToCart;
    }
  });
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('.product-image-zoom');
    if (trigger) {
      const dialog = trigger.closest('.product-main').querySelector('.product-lightbox');
      const image = dialog.querySelector('.lightbox-image');
      image.src = trigger.dataset.fullImage;
      image.alt = trigger.querySelector('img').alt;
      dialog.showModal();
      document.documentElement.classList.add('image-viewer-open');
      dialog.addEventListener('close', () => document.documentElement.classList.remove('image-viewer-open'), { once: true });
    }
    const dialog = event.target.closest('.product-lightbox');
    if (dialog && (event.target === dialog || event.target.closest('.lightbox-close'))) dialog.close();
  });

  } catch(e) { console.error(e); }
})();
})();
